module.exports = __webpack_public_path__ + "img/shield2.3c46da04.png";